/* Whether a reservation's chat holds messages this restaurant user has not read.

   The backend marks unread two ways (add_notification in
   base/views/consumers.py). chat_notification_restaurant_all is set when the
   guest writes and cleared as soon as anyone at the restaurant opens the chat.
   chat_notification_restaurant lists the first names of the staff who still
   have to read it.

   The card used to check the list alone, and that fails quietly: userInfo.name
   falls back to the email when a first name is blank, while the backend stored
   the blank name - so for those users every chat looked read. The bell checked
   the flag, but read the list only when it arrived as a string, and it arrives
   as an array. One rule, used by both. */

const namesFrom = value => {
  if (Array.isArray(value)) return value;
  if (typeof value === "string") {
    return value.split(",").map(name => name.trim()).filter(Boolean);
  }
  return [];
};

export const hasUnreadRestaurantChat = (reservation, userInfo) => {
  if (!reservation?.chat_has_messages) return false;
  if (reservation.chat_notification_restaurant_all) return true;
  const name = userInfo?.name;
  return Boolean(name) && namesFrom(reservation.chat_notification_restaurant).includes(name);
};
